import "./component.scss";

export default function showConfirmation() {
  const $modal = document.querySelector("#kit-confirmation-modal");
  const $closeModalButton = document.querySelector(".js-kit-confirmation-modal-close");
  const $$modal = $($modal);

  $$modal.modal("show");
  $closeModalButton.focus();

  return new Promise(resolve => {
    const $yesButton = $modal.querySelector(".js-kit-confirmation-modal-footer-button-yes");

    $yesButton.addEventListener("click", () => {
      resolve({ result: true });
    });

    $$modal.on("hide.bs.modal", () => {
      resolve({ result: false });
    });
  });
}
